import React from 'react';
import { useSignInWithGoogle } from 'react-firebase-hooks/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import auth from '../../../firebase.init';
import Loading from '../../Shared/Loading/Loading';

const SocialLogin = () => {
    const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(auth)
    const navigate = useNavigate();
    const location = useLocation();
    let from = location.state?.from?.pathname || "/";

    let errorElement;

    if (loading) {
        return <Loading></Loading>
    }

    if (error) {
        errorElement = <p className='text-danger'>Error: {error?.message}</p>
    }

    if (user) {
        navigate(from, { replace: true });
    }

    return (
        <div>
            <div className='d-flex align-items-center'>
                <div style={{ height: '1px' }} className='bg-dark w-50'></div>
                <p className='mt-2 px-2'>or</p>
                <div style={{ height: '1px' }} className='bg-dark w-50'></div>
            </div>
            <h6 className='text-center'>Use your Social Accounts</h6>
            {errorElement}
            <div className='d-flex justify-content-around'>
                <button
                    onClick={() => signInWithGoogle()}
                    className=' btn btn-light border border-2 shadow d-block mx-auto my-2 py-4 hover-zoom'>
                    <i className="fs-2 fa-brands fa-google py-2 px-4"></i>
                </button>
            </div>
        </div>
    );
};

export default SocialLogin;